export const siteSettings = {
  name: "Regal Capitals",
  link: "https://regalcapitals.com",
  email: "support@regalcapitals.com",
  appLink: "https://app.regalcapitals.com",
};
